module.exports = __webpack_public_path__ + "media/images/article/line-57ce0d848a3d798c9ef1d328a043e736.png";